import type { SingularKeys } from '@libs/i18n';

/**
 * Plain-language fallback per field type, used when the catalog ships no
 * description for the field. Keyed by `ActiveTemplateField['type']`.
 */
const TYPE_HELP_KEYS: Record<string, SingularKeys> = {
  string: 'app.orgProfile.field.help.string',
  textarea: 'app.orgProfile.field.help.textarea',
  email: 'app.orgProfile.field.help.email',
  phone: 'app.orgProfile.field.help.phone',
  number: 'app.orgProfile.field.help.number',
  date: 'app.orgProfile.field.help.date',
  boolean: 'app.orgProfile.field.help.boolean',
  select: 'app.orgProfile.field.help.select',
  multi_select: 'app.orgProfile.field.help.multiSelect',
  string_list: 'app.orgProfile.field.help.list',
  number_list: 'app.orgProfile.field.help.list',
  list: 'app.orgProfile.field.help.list',
  table: 'app.orgProfile.field.help.table',
  reference: 'app.orgProfile.field.help.reference',
  file: 'app.orgProfile.field.help.file',
};

/**
 * The tooltip text for a field: the catalog's own description when it has one,
 * otherwise a generic "what to enter here" hint derived from the field type so
 * every field carries guidance, wherever it's filled, edited or reviewed.
 */
export function fieldHelpText(
  field: { type: string; description?: string | null },
  t: (key: SingularKeys) => string,
): string {
  const described = field.description?.trim();
  if (described) return described;
  return t(TYPE_HELP_KEYS[field.type] ?? 'app.orgProfile.field.help.default');
}
